@let isInStock = meal().is_in_stock;

<button
  class="meal__container"
  [ngClass]="{ disabled: !isInStock }"
  (click)="onAddToCart.emit()"
>
  @if (discountPercentage()) {
    <span class="meal__discount">{{ discountPercentage() | number:'.0-0' }}%</span>
  }
  @if (displayImage()) {
    <img
      [src]="displayImage()"
      loading="lazy"
      decoding="async"
      [alt]="meal().name"
      [width]="150"
      [height]="150"
      onerror="onerror=null;src='assets/images/image-placeholder.svg';"
      class="meal__img"
    />
  }

  <div class="meal__content">
    <div class="meal__info">
      <div class="meal__info__data">
        <div class="meal__info__name" [innerHTML]="meal().name"></div>
        <div
          class="meal__info__description"
          [innerHtml]="processedDescription()"
        ></div>
      </div>

      @if (meal().average_rating != '0') {
        <div class="meal__actions__rating">
          <i class="icon-star"></i>
          <p>{{ meal().average_rating | number: '.0-1' }}</p>
        </div>
      }
    </div>
    <div class="meal__actions">
      <div class="meal__info__price">
        @let minorUnit = meal().prices.currency_minor_unit;
        @let isDiscounted = displayRegularPrice() > displayEffectivePrice();

        @if (isDiscounted) {
          <span>
            {{ displayEffectivePrice() | formattedCurrency: minorUnit }}
          </span>
        }
        <span [class.line-through]="isDiscounted">
          @if (showFromPrefix()) { From }{{ displayRegularPrice() | formattedCurrency: minorUnit }}
        </span>
      </div>
      @if (!isInStock) {
        <div class="meal__actions_out-of-stock">
          <span class="meal__actions_out-of-stock_label">
            This item is temporarily out of stock
          </span>
        </div>
      } @else {
        <app-button
          class="meal__actions__btn"
          [size]="ButtonSize.Icon"
          [style]="ButtonStyle.Primary"
        >
          <i class="icon-plus"></i>
        </app-button>
      }
    </div>
  </div>
</button>
